var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemMultipleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6797 13.2344H21.8828V0.820312C21.8828 0.367281 21.5155 0 21.0625 0H7.9375C7.48447 0 7.11719 0.367281 7.11719 0.820312V13.2344H1.32031C0.867281 13.2344 0.5 13.6017 0.5 14.0547V27.1797C0.5 27.6327 0.867281 28 1.32031 28H27.6797C28.1327 28 28.5 27.6327 28.5 27.1797V14.0547C28.5 13.6017 28.1327 13.2344 27.6797 13.2344ZM20.2928 14.875H21.9334V18.1016H20.2928V14.875ZM7.0584 14.875H8.69902V18.1016H7.0584V14.875ZM13.6797 1.64062H15.3203V4.92188H13.6797V1.64062ZM8.75781 1.64062H12.0391V5.74219C12.0391 6.19522 12.4063 6.5625 12.8594 6.5625H16.1406C16.5937 6.5625 16.9609 6.19522 16.9609 5.74219V1.64062H20.2422V13.149H8.75781V1.64062ZM2.14062 14.875H5.41777V18.9219C5.41777 19.3749 5.78505 19.7422 6.23809 19.7422H9.51934C9.97237 19.7422 10.3396 19.3749 10.3396 18.9219V14.875H13.6797V26.3594H2.14062V14.875ZM26.8594 26.3594H15.3203V14.875H18.6521V18.9219C18.6521 19.3749 19.0194 19.7422 19.4725 19.7422H22.7537C23.2067 19.7422 23.574 19.3749 23.574 18.9219V14.875H26.8594V26.3594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemMultipleIcon);
export default __webpack_public_path__ + "static/media/item-multiple-icon.f19cc46c9a90b837f3b762f56ffd795a.svg";
export { ForwardRef as ReactComponent };